<template>
       <!-- FOOTER -->
                        
    <div id="navigation" class="mt-40">
        <!-- <nav class="md:flex md:justify-between flex-col md:items-center">
            <ul class="md:flex justify-between items-center mt-10">
                <li class="md:mx-10 md:my-0 my-2 text-indigo-600 font-medium">Vote</li>
                <li class="md:mx-10 md:my-0 my-2 text-indigo-600 font-medium">Entrepreneurs</li>
                <li class="md:mx-10 md:my-0 my-2 text-indigo-600 font-medium">About</li>
            </ul>
        </nav> -->
        <div class="text-center mt-8">
            <p class="font-medium">&copy; Created and maintained by <a class="text-indigo-600" href="https://qurulab.com">QuruLab</a></p>
        </div>
    </div>
</template>


